import { render } from "./PlayerModal.vue?vue&type=template&id=2b6f83e2"
import script from "./PlayerModal.vue?vue&type=script&lang=js"
export * from "./PlayerModal.vue?vue&type=script&lang=js"

import "./PlayerModal.vue?vue&type=style&index=0&id=2b6f83e2&lang=css"

import exportComponent from "C:\\Users\\windows\\Documents\\GitHub\\ValoAssist_web - 복사본\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__